"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnauthorizedError = UnauthorizedError;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _reactRedux = require("react-redux");
var _ModalTypes = require("@studio/constants/ModalTypes");
var _Static = require("../../../components/Modals/Static/Static.styled");
var _hooks = require("../../../hooks");
var _featureFlags = require("@studio/feature.flags/featureFlags");
function UnauthorizedError() {
  var isOpen = (0, _reactRedux.useSelector)(function (state) {
    var _state$modal;
    return ((_state$modal = state.modal) === null || _state$modal === void 0 ? void 0 : _state$modal.type) === _ModalTypes.UNAUTHORIZED_ERROR;
  });
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var isPresenterStandalone = (0, _hooks.usePresenterStandaloneContext)();
  var requireSpeakerAuth = (0, _featureFlags.shouldHaveFeature)('studio.requirePresenterAuth');
  var showModal = (requireSpeakerAuth || !isPresenterStandalone) && isOpen;
  var title = isStudioLite ? 'Your authentication was reset' : 'Authentication Error';
  var content = isStudioLite ? 'Click the “Leave session” button on this screen and rejoin the session.' : 'Your authentication was reset. Please rejoin the session.';
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    isOpen: showModal,
    backdrop: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Static.StyledModalHeader, null, title), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, null, /*#__PURE__*/_react["default"].createElement("p", null, content)));
}